<template>
  <main role="main" class="col content-spacing">
    <loading-list v-if="viewData.loading"></loading-list>
    <b-container v-else>
      <b-row>
        <b-col>
          <div
            class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
          >
            <h1 class="h2">
              {{ viewData.id ? `Editar ${state.name}` : 'Nova Distribuidora' }}
            </h1>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-breadcrumb
            :items="[
              {
                text: 'Lista de Distribuidoras',
                href: '#/distributors',
              },
              {
                text: 'Cadastro de Distribuidoras',
                href: '#',
                active: true,
              },
            ]"
          ></b-breadcrumb>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-form>
              <error-container v-bind:errors="viewData.errors || []" />

              <b-form-group label="Nome (Sigla)">
                <b-form-input
                  v-model="state.name"
                  required
                  placeholder="Informe o nome"
                  :state="isOk('name')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('name')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="CNPJ">
                <b-form-input
                  v-model="state.socialNumber"
                  required
                  placeholder="Informe o CNPJ"
                  :state="isOk('socialNumber')"
                  v-mask="['##.###.###/####-##']"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('socialNumber')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-3"
                label="Denominação"
                label-for="input-group-3"
              >
                <b-form-select v-model="state.initials" :state="isOk('initials')">
                  <option disabled value>Selecione a denominação</option>
                  <option value="CEMIG (Minas Gerais)">CEMIG (Minas Gerais)</option>
                </b-form-select>
                <b-form-invalid-feedback>{{
                  getError('initials')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-3"
                label="Fluxo de cadastro da UC"
                label-for="input-group-3"
              >
                <b-form-select v-model="state.ucFlow" :state="isOk('ucFlow')">
                  <option disabled value>Selecione o fluxo</option>
                  <option value="WITHOUT_LOGIN_WITHOUT_ID">Sem login, Sem identidade</option>
                  <option value="WITHOUT_LOGIN_WITH_ID">Sem login, Com identidade</option>
                  <option value="WITH_LOGIN_WITHOUT_ID">Com login, Sem identidade</option>
                  <option value="WITH_LOGIN_WITH_ID">Com login, Com identidade</option>
                </b-form-select>
                <b-form-invalid-feedback>{{
                  getError('ucFlow')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="URL do Portal da Distribuidora">
                <b-form-input
                  v-model="state.distributorUrl"
                  required
                  placeholder="Informe a URL do Portal da Distribuidora"
                  :state="isOk('distributorUrl')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('distributorUrl')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Código da Distribuidora">
                <b-form-input
                  v-model="state.numberDist"
                  required
                  placeholder="Informe o Código da Distribuidora"
                  :state="isOk('initials')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('numberDist')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-3"
                label="Região"
                label-for="input-group-3"
              >
                <b-form-select v-model="state.region" :state="isOk('region')">
                  <option disabled value>Selecione a região</option>
                  <option value="norte">Norte</option>
                  <option value="nordeste">Nordeste</option>
                  <option value="sul">Sul</option>
                  <option value="sudeste">Sudeste</option>
                  <option value="centro_oeste">Centro Oeste</option>
                </b-form-select>
                <b-form-invalid-feedback>{{
                  getError('region')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Estado"
                label-for="input-1"
              >
                <b-form-select
                  v-model="state.state"
                  :options="viewData.states"
                  :state="isOk('state')"
                >
                  <option disabled value>Selecione um estado</option>
                </b-form-select>
                <b-form-invalid-feedback>{{
                  getError('state')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Cidade">
                <b-form-input
                  v-model="state.city"
                  placeholder="Informe a cidade"
                  :state="isOk('city')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('city')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Bairro"
                label-for="input-1"
              >
                <b-form-input
                  v-model="state.district"
                  placeholder="Informe o Bairro"
                  :state="isOk('district')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('district')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Endereço"
                label-for="input-1"
              >
                <b-form-input
                  v-model="state.address"
                  placeholder="Informe o Endereço"
                  :state="isOk('address')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('address')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Numero"
                label-for="input-1"
              >
                <b-form-input
                  v-model="state.number"
                  placeholder="Informe o Número"
                  :state="isOk('number')"
                  @keypress="isNumber($event)"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('number')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Complemento"
                label-for="input-1"
              >
                <b-form-input
                  v-model="state.complement"
                  placeholder="Informe o Complemento"
                  :state="isOk('complement')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('complement')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Telefone"
                label-for="input-1"
              >
                <b-form-input
                  v-model="state.phone"
                  required
                  placeholder="Informe o Telefone"
                  v-mask="['(##) ####-####', '(##) #####-####']"
                  :state="isOk('phone')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('phone')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group id="input-group-1" label="CEP" label-for="input-1">
                <b-form-input
                  v-model="state.zipCode"
                  placeholder="Informe o CEP"
                  :state="isOk('zipCode')"
                  v-mask="['#####-###']"
                  @blur="fillCompleteAddress($event)"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('zipCode')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Email">
                <b-form-input
                  v-model="state.email"
                  required
                  placeholder="Informe o email"
                  :state="isOk('email')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('email')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <submit-button
                v-bind:action="() => save()"
                v-bind:label="'Salvar'"
              ></submit-button>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </main>
</template>

<script>
import helpers from '../../vue/helpers';
import { Api } from '../../vue/api';
import StatesJson from '../../vue/estados.json';

const API = new Api();

export default {
  name: 'distributor-edit',
  data: function() {
    return {
      state: {
        state: '',
        socialNumber: '',
        type: '',
        region: '',
        email: '',
        phone: '',
        zipCode: '',
        complement: '',
        number: '',
        district: '',
        address: '',
        city: '',
      },
      viewData: {
        id: 0,
        loading: false,
        errors: [],
        states: [],
      },
    };
  },
  computed: {},
  beforeMount: async function() {
    this.viewData.states = StatesJson.estados;
    const _id = this.$route.params ? this.$route.params.id : 0;

    if (_id) {
      this.viewData.id = _id;

      try {
        this.viewData.loading = true;

        const result = await API.post('/execute', {
          path: '/distributor/' + _id,
          method: 'get',
        });

        this.state = { ...result.model };
        this.viewData.loading = false;
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    }
  },
  methods: {
    getError(property) {
      return helpers.getError(this.viewData.errors, property);
    },
    isNumber($event) {
      return helpers.isNumber($event);
    },
    isOk(property) {
      let hasError = helpers.hasError(this.viewData.errors, property);
      if (hasError) {
        return false;
      }
    },
    updateUrl(url) {
      this.state.url = url;
    },
    setLoadingPhoto(loading) {
      this.viewData.loadingPhoto = loading;
    },
    async save() {
      try {
        let data = _.cloneDeep(this.state);

        const result = await API.post('/execute', {
          path: this.viewData.id
            ? `/distributor/${this.viewData.id}`
            : '/distributor/',
          method: this.viewData.id ? 'put' : 'post',
          data: data,
        });

        this.$toast.success('Distribuidora incluída com sucesso');

        this.$router.push('/distributors');
      } catch (ex) {
        this.viewData.errors = helpers.getErrors(ex);
      }
    },
  },
  components: {
    'image-upload': require('../image-upload.vue').default,
  },
};
</script>
